import React, {useContext, useEffect, useState} from "react";
import axios from "axios";
import {
    Elink, FetchEstimateRoomInventoryUrl, UpdateRoomInventoryUrl, UploadInventoryOrRoomImagesUrl, FetchEstimateRoomPicturesUrl, DeleteImageUrl, DeleteInventoryEstimateUrl, CompanySubdomain
} from "../CommonComponents/Routes";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import UpdateFloorModal from "./UpdateFloorModal";
import imageCompression from "browser-image-compression";
import DefaultAlerts from "../CommonComponents/DefaultAlerts";
import {Modal} from "react-bootstrap";
import {Animation} from "./Animation";
import MobileLinkLoader from "./MobileLinkLoader";
import {AnimationPrevious} from "./AnimationPrevious";
import {GetTextColor} from "./GetTextColor";

const RoomDetail = () => { // this component is used to show details of room inventories and room pictures
    const RecordController = useContext(RecordsManagementContext);
    const PageView = useContext(ViewMangementContext);
    const IsCustomerEditEstAftrBook = RecordController.IsJobOpen;
    const [, forceUpdate] = React.useState(0);
    const [EstimateRoomInventory, SetEstimateRoomInventory] = useState({});
    const [Display, SetDisplay] = useState({display: false, room_id: 0});
    const [InventoryImage, SetInventoryImage] =useState({});
    const [imageModal, setimageModal] = useState("")
    const [Loader, SetLoader] = useState(false)
    const [modal, SetModal] = useState(false)
    const [change, SetChange] = useState(false)
    const [BodyState, setBodyState] = useState("MINI-LOADING")
    const [Imagecount, SetImagecount] = useState(0);
    let CustomerInvReq = RecordController.ML_Start.CustomerInventoryRequest;
    let subdomains = RecordController.CP_PageDetails.subdomains
    useEffect(() => {
        if (RecordController.Click) {
            Animation("room-detail",RecordController.Click);// add animation class
        }
        axios({// fetch data using post request
            method: 'post',
            url: FetchEstimateRoomInventoryUrl,
            params: {estimate_key: Elink, est_room_id: RecordController.Room.Id}
        }).then(async (response) =>{
            await SetLoader(false);
            await SetEstimateRoomInventory(response.data.InventoryHash);
            await setBodyState("Get Details");
            await SetImagecount(response.data.ImageCount)
            if(response.data.ImageCount > 0) {
                await SetLoader(true);
                axios({
                    method: 'post',
                    url: FetchEstimateRoomPicturesUrl,
                    params: {estimate_key: Elink, est_room_id: RecordController.Room.Id}
                }).then(async (response) => {
                    await SetInventoryImage(response.data);
                    await SetLoader(false);
                });
            }
        });
    }, [])

    const InventoryDetail = (props) =>{ // showing all inventories details
        let Inventory = props.Inventory
        return(
            <>
                <div className="number-active-white text-center">
                    <AddOrSubQty Inventory={Inventory} Id={Inventory.Id} For={'-'}/>
                    <p className="text-design" style={{marginTop: "1rem"}}>{Inventory.Name}</p>
                    <div className="input-st">
                        <input type="text" pattern="[0-9]*"  style={{fontSize: "15px!important",padding: "0px", backgroundColor: Inventory.Qty > 0 ? CustomerInvReq.ButtonColor : '', color: Inventory.Qty > 0 ? GetTextColor(CustomerInvReq.ButtonColor) : ''}}
                               defaultValue={Inventory.Qty > 0 ? Inventory.Qty : ''} onBlur={(e) => ChangeQtyFor(Inventory,parseInt(e.target.value))}
                               disabled />
                    </div>
                    <AddOrSubQty Inventory={Inventory} Id={Inventory.Id} For={'+'}/>
                </div>
            </>
        )
    }

    const ChangeQtyFor = (inventory,value) => {//change quantity manually.
        let Inventory = inventory;
        Inventory['Qty'] = value;
    }

    const AddOrSubQty = (props) => {//increase or decrease btns
        if (IsCustomerEditEstAftrBook) {
            return (
                <span className={props.For === '+' ? 'plus' : 'minus'} style={{cursor: "pointer"}}
                      onClick={() => UpdateQty(props.Inventory, props.For === '+' ? 'Increment' : 'Decrement', props.Id)}>
                    {props.For}
                </span>
            )
        } else {
            return ''
        }
    }
    const UpdateQty = (inventory, type, inventory_id) => { // increase or decrease the quantity
        SetChange(true);
        if (inventory_id !== '') {
            let isAlreadyExist = false,
                InventoryId = 0
            if (EstimateRoomInventory != null) {
                let inventories = EstimateRoomInventory
                Object.entries(inventories).map(([id, Inventory]) => {
                    if (Inventory.Id === inventory_id) {
                        isAlreadyExist = true
                        InventoryId = id
                    }
                })
                if (isAlreadyExist === true && InventoryId !== 0) {
                    if (type === 'Increment') {
                        inventories[InventoryId].Qty += 1
                    } else if (type === 'Decrement' && inventories[InventoryId].Qty > 0) {
                        inventories[InventoryId].Qty -= 1
                        if(inventories[InventoryId].Qty === 0){
                            delete inventories[InventoryId]
                            axios({//post request is send to the "delete inventory" if item count is zero
                                method: 'post',
                                url: DeleteInventoryEstimateUrl,
                                data: {
                                    estimate_key: Elink,
                                    inv_est_id: InventoryId
                                }
                            });
                        }
                    }
                }
                SetEstimateRoomInventory(inventories);
                forceUpdate(n => !n)
            }
        }
    }
    const AddItems = (state) =>{ // this method is used to add items (updating the inventory and open new page add inventories)
        state === 'add' ? RecordController.SetClick('upward') : RecordController.SetClick('next')
        state === 'add' ? AnimationPrevious("upward-go","room-detail","ADD_INVENTORIES", PageView) :
            AnimationPrevious( "next-go",  "room-detail",  "REVIEW_AND_SUBMIT", PageView)
        RecordController.SetRoomInventories(EstimateRoomInventory);
        axios({//post request is send to the "update_inventories"
            method: 'post',
            url: UpdateRoomInventoryUrl,
            data: {
                estimate_key: Elink,
                room_est_id: RecordController.Room.Id,
                inventory_estimates: EstimateRoomInventory,
                floor_id: RecordController.Room.FloorId,
                room_id: RecordController.Room.RoomId
            }
        }).then(async (response)=>{
            let Message = response.data.Message
            let current_location = window.location.href;
            let new_location = current_location.replace("client_estimate_mobile_link", "client_estimate");
            if(Message && Message.Text === "Expired Link"){
                window.location = new_location
            }
            else{
                if (Message && Message.Status && Message.Status === "failed") {
                    PageView.setAlertProperty({
                        Message: Message.Text,
                        Type: Message.Type,
                        Show: true,
                        AutoHide: true
                    })
                    window.location.reload();
                } else{
                    await RecordController.setRoom(response.data);
                }
            }
        })
    }
    const BackToMyRooms = (type) =>{// back to home page
        type === 'back' ? RecordController.SetClick('back') : RecordController.SetClick('downward')
        type === 'back' ? AnimationPrevious("back-go",  "room-detail", "SHOW_MOBILE_LINK_MY_ROOMS", PageView) :
            AnimationPrevious("downward-go",  "room-detail", "SHOW_MOBILE_LINK_MY_ROOMS", PageView)
        RecordController.SetDone(false);
        updateRoomInventories();
    }

    const updateRoomInventories=()=>{ // this component is used to update the inventories, if inventory quantities are changed
        if(change) {
            axios({//post request is send to the "update_inventories" function for updating the inventories of the estimate.
                method: 'post',
                url: UpdateRoomInventoryUrl,
                data: {
                    estimate_key: Elink,
                    room_est_id: RecordController.Room.Id,
                    inventory_estimates: EstimateRoomInventory,
                    floor_id: RecordController.Room.FloorId,
                    room_id: RecordController.Room.RoomId
                }
            }).then(async (response) => {
                // as if room deleted from web when click on update, we are creating new room with all inventories in it
                // so update the set room to be new( incase delete from web ) or old room with all inventories
                let Message = response.data.Message
                let current_location = window.location.href;
                let new_location = current_location.replace("client_estimate_mobile_link", "client_estimate");
                if(Message && Message.Text === "Expired Link"){
                    window.location = new_location
                }
                else{
                    if (Message && Message.Status && Message.Status === "failed") {
                        PageView.setAlertProperty({
                            Message: Message.Text,
                            Type: Message.Type,
                            Show: true,
                            AutoHide: true
                        })
                        window.location.reload();
                    }
                    await RecordController.setRoom(response.data);
                }
            });
        }
    }

    const getCompanyFloors = () =>{ // open update floor modal
        RecordController.setCustomItemModal(true);
        updateRoomInventories();
    }

    const Cancel = ()=>{ // cancel takes to review and submit page
        RecordController.SetClick('downward')
        RecordController.SetEditRoom(false);
        AnimationPrevious ( "downward-go",  "room-detail", "REVIEW_AND_SUBMIT", PageView);
    }

    const ShowDisplay=(props)=>{ // component is used to send current room id, used for take picture
        Display['display'] && Display['room_id'] === props.Room.Id? SetDisplay({display: false, room_id: props.Room.Id}) : SetDisplay({display: true, room_id: props.Room.Id})
        updateRoomInventories();
    }

    const getFile = async (file) => { // get image file and allowed extensions ( ["jpg", "jpeg", "gif", "png"]; )
        let b = []
        const options = {
            maxSizeMB: 1,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        }
        let allowedExtension = ["jpg", "jpeg", "gif", "png", "JPG", "JPEG", "GIF", "PNG"];
        for (let i=0; i < file.length; i++) {
            let extName =  allowedExtension.indexOf(file[i].name.split('.').pop()) > -1
            let message = extName ? file[i].name+ " is not saved, picture quality of "+file[i].name+"  is too low" : file[i].name+ " is not saved, Only image file with extension: .jpg, .jpeg, .gif or .png is allowed"
            if ( extName && file[i].size > 1000){
                const compressedFile = file[i].size > 1000000 ? await imageCompression(file[i], options) : file[i];
                let cp = await toBase64(compressedFile) // used to convert file to base 64
                b.push(cp)
            }else{
                PageView.setAlertProperty({
                    Message: message,
                    Type: "warning",
                    Show: true,
                    AutoHide: false
                })
            }
        }
        return b;
    }

    const onImageChange =  async (event) => {// save the images by sending post request
        let file = event.target !== undefined ? event.target.files : event
        if (file && file.length < 11)  {
            let files = await getFile(file) // it will check the extension and size of the image and if needed it will compress the images
            SetLoader(true)
            try {
                let cookie = document.cookie.split('employee_id=')[1]
                axios({
                    method: 'post',
                    url: UploadInventoryOrRoomImagesUrl,
                    data: {
                        estimate_key: Elink,
                        room_est_id: RecordController.Room.Id,
                        employee_key: cookie,
                        image_files: files,
                        picture_type: "Room Inventory"
                    }
                }).then(async (response)=>{
                    await SetInventoryImage(response.data);
                    await SetLoader(false);
                })
            } catch (error) {
                console.log(error);
            }
        }else {//if select images are more than 10 then it will shows the alert message.
            if (event.target !== undefined){
                event.target.value = null;
            }
            PageView.setAlertProperty({
                Message: "You can select up to ten images",
                Type: "warning",
                Show: true,
                AutoHide: true
            })
        }
    }

    const toBase64 = file => new Promise((resolve, reject) => {//encode the images
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const hiddenFileInput = React.useRef(null);

    const handleClick = event => {
        hiddenFileInput.current.click();
    };

    const DeleteImage = (props) => { // delete image from frontend as well as from backend
        let image_id = props.id;
        delete InventoryImage[props.id];
        let element = document.getElementsByClassName(image_id);
        element[0].setAttribute('style','display: none;');
        element[0].nextElementSibling.setAttribute('style','display: none;');
        element[1].setAttribute('style','display: none;');
        element[1].nextElementSibling.setAttribute('style','display: none;');
        SetInventoryImage(InventoryImage);
        axios({ // delete image from database using post request
            method: 'post',
            url: DeleteImageUrl,
            data: {
                estimate_key: Elink,
                image_id: image_id,
                est_room_id: RecordController.Room.Id
            }
        })
    }

    const zoomImage = (image) => {//used for adding the feature of zoom in to the image
        if(subdomains.includes(CompanySubdomain)){
            setimageModal(image)
        }
        else {
            setimageModal(image.replace("thumb", "medium"));
        }
        SetModal(true);
    }

    const handleModal = () => {
        SetModal(false);
        setimageModal('');
    }
    const handleCamera =() => {// opening camera through room page
        RecordController.SetClick('no-class')
        RecordController.SetCameraFrom("Room"); // update camera from room
        PageView.Set("TAKE_PICTURE");
    }

    const ImageDetail=(props)=>{ //  showing the images
        var src, img
        if( subdomains.includes(CompanySubdomain)){
            src = props.Image[0]
            img = props.Image[1]
        }
        else {
            src = props.Image
            img = props.Image
        }
        return(
            <>
                <img style={{margin: "1.5%", borderRadius: "12px", height: "80%", width: "25%"}}
                     onClick={()=> zoomImage(img)} data-toggle="modal" className= {props.id} id={props.device_type}
                         data-target="#Modal-2" src={src} alt="preview image"/>
                <span className={'btn image-cross'}
                      onClick={()=>DeleteImage({id: props.id, image: props.Image, device_type: props.device_type})}><b>X</b></span>
            </>
        )
    }
    const roomDetailRecord = (device_type) => { // detail record
        return (
            <>
                <div className="container">
                    <DefaultAlerts/>
                    <div className="row my-items-row">
                        <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2" style={{width: "15%!important"}}>
                            {
                                RecordController.EditRoom ?
                                    <button className="btn btn-st-back" type="submit" onClick={()=>Cancel()}
                                            style={{color: GetTextColor(CustomerInvReq.ButtonColor), backgroundColor: CustomerInvReq.ButtonColor}}>Cancel</button> :
                                    RecordController.Done  ? '' :
                                        <button className="btn btn-st-back" type="submit" onClick={()=>BackToMyRooms('back')}
                                                style={{color: GetTextColor(CustomerInvReq.ButtonColor), backgroundColor: CustomerInvReq.ButtonColor}}>Back</button>
                            }
                            {
                                RecordController.EditRoom ?
                                    <div className="arrow-st" onClick={()=>Cancel()}>
                                        <i className="fa fa-times" aria-hidden="true" style={{color: GetTextColor(CustomerInvReq.BackgroundColor), fontSize: "25px"}}></i>
                                    </div> :
                                    RecordController.Done ? " " :
                                        <div className="arrow-st" onClick={()=>BackToMyRooms('back')} >
                                            <i className={"fas fa-angle-left"} style={{fontSize: "35px",color: GetTextColor(CustomerInvReq.BackgroundColor)}}></i>
                                        </div>
                            }
                        </div>
                        <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xl-2">
                            <div className="text-center">
                                <h3 style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}><b>{RecordController.Room.Name}</b></h3>
                            </div>
                        </div>
                        <div className="col-2 col-sm-2 col-md-2 col-lg-2" style={{width: "15%!important"}}>
                            {RecordController.Done ?
                                <div className={"text-center"}>
                                    <h5 style={{fontSize: "100%", color: GetTextColor(CustomerInvReq.BackgroundColor), cursor: "pointer", marginLeft:"-0.8rem", marginTop: "5%"}}
                                        onClick={() => BackToMyRooms('done')}><b>DONE</b></h5>
                                </div> :
                                <div className="dropdown">
                                    <div className="camera" data-toggle="dropdown" style={{cursor: "pointer"}}>
                                        {
                                            RecordController.Done ? '' :
                                                <i className="fa fa-camera" style={{fontSize:"35px", color: GetTextColor(CustomerInvReq.BackgroundColor)}}
                                                   onClick={() => ShowDisplay({Room: RecordController.Room})}></i>
                                        }

                                    </div>
                                    <ul className="dd-menu-camera dropdown-menu dropdown-menu-right">
                                        <li className={'dropdown-item'} onClick={() => handleCamera()}>Take Photo</li>
                                        <li className={'dropdown-item'} id="upload-st" onClick={handleClick}>Choose
                                            photo from Library
                                        </li>
                                        <input
                                            type="file"
                                            ref={hiddenFileInput}
                                            onChange={onImageChange}
                                            style={{display: 'none'}}
                                            multiple={true}
                                            accept='image/*'
                                        />
                                    </ul>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="text-center" style={Object.keys(EstimateRoomInventory).length > 0 ? {marginTop: "9%"}: {marginTop: "11%"}}>
                        {
                            // add loader because sometimes it takes time to fetch the details
                            BodyState === "MINI-LOADING" ? <MobileLinkLoader Height={"45vh"}/> :
                            <div className="row d-flex justify-content-center align-items-center h-100">
                                <div className="col-sm-12 col-md-9 col-lg-6 col-xl-5">
                                    <div className="headline my-items-heading">
                                        {Object.keys(EstimateRoomInventory).length > 0 ? <h3><b>My Items</b></h3> : <h4></h4>}
                                        <h6 className="btn-sm btn-light" style={{width: "25%", height: "2rem",backgroundColor: "#e6ecf2", alignItems: "center", cursor: "pointer"}}
                                            onClick={() => getCompanyFloors({Room: RecordController.Room})}>
                                            { RecordController.UpdateFloor && RecordController.Room.Id ? "Updating.." : "Floor: "+ RecordController.Room.Floor }
                                        </h6>
                                    </div>
                                    <div className="counter-item text-center" style={{maxHeight: Imagecount > 0 ? "30vh" : "46vh", overflow: "scroll" }}>
                                        {Object.keys(EstimateRoomInventory).length > 0 ?
                                            Object.entries(EstimateRoomInventory).map(([id, Inventory]) => {
                                                return (
                                                    <InventoryDetail key={id} Inventory={Inventory}/>
                                                )
                                            })
                                            : <h3><b>No items yet.</b></h3>}
                                    </div>
                                    {
                                        Imagecount > 0 ?
                                            <div style={{margin: "1.5% auto",width: "80%", height: "16.5vh", overflow: "scroll"}}>
                                                {
                                                    Loader ?
                                                        <img src={process.env.PUBLIC_URL + "/Images/Loader18.gif"}
                                                             style={{width: "70%", height: "100%"}}/> :
                                                        Object.entries(InventoryImage).reverse().map(([id, image]) => {
                                                            return (<ImageDetail key={id} Image={image} id={id} device_type={device_type}/>)
                                                        })
                                                }
                                            </div>
                                            :
                                            ""
                                    }
                                    <UpdateFloorModal Floor={RecordController.Room} For={'Room'}/>
                                    {
                                        RecordController.EditRoom ?
                                            <button className="btn btn-update" type="submit" onClick={() => AddItems('update')}
                                                    style={{borderRadius: "8px", padding: "7px 0", backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}>
                                                <b>Update</b>
                                            </button> :
                                            ''
                                    }
                                    <br/><br/>
                                    <button className="btn btn-st-add" type="submit" onClick={() => AddItems('add')}
                                                      style={{ backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}>
                                        <b>ADD ITEM +</b>
                                    </button>
                                </div>
                                <Modal className="zoom-image-modal" show={modal} onHide={() => handleModal()}>
                                    <div className={"modal-header"} style={{backgroundColor: "transparent", padding: "0px",border: 'none'}}>
                                    <span className={"close btn"} aria-hidden="true"
                                          style={{
                                              margin: "-2.6rem -1.2rem -2rem auto",
                                              color: "gray",
                                              fontSize: "40px"
                                          }}
                                          onClick={() => handleModal()}>&times;</span>
                                    </div>
                                    <div className={"modal-body"} style={{
                                        backgroundColor: "transparent",
                                        padding: '0px'
                                    }}>
                                        <img style={{width: "100%", height: "60vh",backgroundColor: "transparent", border: 'none'}}
                                             src={imageModal} alt="preview image"/>
                                    </div>
                                </Modal>
                            </div>
                        }
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <section className="item-section-2 desktop-vw" style={{ background: CustomerInvReq.BackgroundColor}}>
                <div className={"room-detail"} style={{width: "100vw", position: "relative"}}>
                    {roomDetailRecord("desktop-vw")}
                </div>
            </section>
                <section className="mobile-vw">
                    <div className="container-mv">
                        <svg viewBox="0 0 490 510"
                             preserveAspectRatio="xMinYMin meet"
                             style={{zIndex: -1}} id="svg-mv">
                            <path d="M0, 170 C360, 30, 630,
                510 595,-400 L900, 00 L0, 0 Z"
                                  style={{stroke: "none",fill: CustomerInvReq.BackgroundColor}}>
                            </path>
                        </svg>

                    </div>
                    <div className={"room-detail"} style={{width: "100vw", position: "relative"}}>
                        {roomDetailRecord("mobile-vw")}
                    </div>
                </section>
        </>
    )
}
export default RoomDetail;